export var buildings = {};

buildings.types = ['normal','good-idle','bad-idle'];
buildings.leftFloors = [0,0,0,0,1,2];
buildings.rightFloors = [0,0,0,0,1,2];
buildings.default = [0,0,0,0,1,2];
buildings.iterate = [0,0,0,0,1,2];